export const MAX_USERNAMES = 6;

export const USERNAME_FORMATS = [
  { key: 'firstlast', build: ({ first, last }) => join(first, last) },
  { key: 'first.last', build: ({ first, last }) => join(first, '.', last) },
  { key: 'first_last', build: ({ first, last }) => join(first, '_', last) },
  { key: 'flast', build: ({ first, last }) => join(first[0], last) },
  { key: 'firstl', build: ({ first, last }) => join(first, last[0]) },
  { key: 'nick', build: ({ nick }) => nick },
  { key: 'nicklast', build: ({ nick, last }) => join(nick, last) },
  { key: 'nick.last', build: ({ nick, last }) => join(nick, '.', last) },
  { key: 'lastfirst', build: ({ first, last }) => join(last, first) },
  { key: 'first', build: ({ first }) => first },
  { key: 'last', build: ({ last }) => last },
];

export function generateUsernames(firstName, lastName, nickname, limit = MAX_USERNAMES) {
  const parts = {
    first: normalizeNamePart(firstName),
    last: normalizeNamePart(lastName),
    nick: normalizeNamePart(nickname),
  };

  const variants = new Set();
  for (const format of USERNAME_FORMATS) {
    const value = format.build(parts);
    if (value && value.length >= 3) variants.add(value);
    if (variants.size >= limit) break;
  }

  return [...variants];
}

export function normalizeNamePart(value = '') {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

function join(...parts) {
  return parts.every(Boolean) ? parts.join('') : '';
}
